import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { NetworkStatus } from '@apollo/client';

import { useSegmentQuery } from '@occc/graphql';
import { actions } from '@occc-app/routes/Segment/redux';

import { usePollingControl } from './use-polling-control.hook';

import { POLLING_INTERVAL_MS } from '../segments.constants';

export type UseGetSegmentByIdParams = {
  idEquals: string;
  chainIdEquals?: string;
  isPollingEnabled?: boolean;
  pollInterval?: number;
};

export const useGetSegmentById = ({
  idEquals,
  chainIdEquals,
  isPollingEnabled = false,
  pollInterval = POLLING_INTERVAL_MS,
}: UseGetSegmentByIdParams) => {
  const dispatch = useDispatch();
  const response = useSegmentQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    ...(isPollingEnabled && { pollInterval }),
    variables: {
      filter: {
        idEquals,
        ...(chainIdEquals ? { chainIdEquals } : {}),
        isDeleted: false,
      },
    },
  });

  usePollingControl(isPollingEnabled, response.stopPolling);

  const node = response.data?.segments?.edges[0]?.node || null;

  useEffect(() => {
    if (node) {
      dispatch(actions.requestSegmentOK(node));
    }
  }, [dispatch, node]);

  const isInitialLoading = response.networkStatus === NetworkStatus.loading;
  const isPolling = response.networkStatus === NetworkStatus.poll;

  return {
    ...response,
    data: node,
    isInitialLoading,
    isPolling,
  };
};
